// gsap register plugin
gsap.registerPlugin(ScrollTrigger);

const gridItems = [...document.querySelectorAll("[data-js='feed']")];

// Initialize Lenis
const lenis = new Lenis({ orientation: "horizontal" });

// Listen for the scroll event and log the event data
lenis.on("scroll", (e) => {
  console.log(e);
});

window.addEventListener(
  "wheel",
  (e) => {
    // Si le scroll horizontal est plus fort que le vertical
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      // Empêche le scroll par défaut
      e.preventDefault();

      // Crée un nouvel événement wheel simulé vertical
      const simulatedEvent = new WheelEvent("wheel", {
        deltaY: e.deltaX,
        deltaX: 0,
        bubbles: true,
        cancelable: true,
      });

      // Redispatch sur la même cible
      e.target.dispatchEvent(simulatedEvent);
    }
  },
  { passive: false }
);

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// start animation
gridItems.forEach((item) => {
  const yPercentRandomVal = gsap.utils.random(-15, 15);
  gsap
    .timeline()
    .addLabel("start", 0)
    .to(
      item,
      {
        ease: "none",
        yPercent: yPercentRandomVal,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
          end: "top top",
          scrub: true,
          horizontal: true,
        },
      },
      "start"
    );
});
